import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'components/shared/Layout';
import { bookingShape } from 'constants/propTypes';
import AddOns from './AddOns';

const Assistance = ({ booking, canAddSpecialAssistanceToBooking }) => (
  <Row data-cy="payments-tab">
    <AddOns booking={booking} canAddSpecialAssistanceToBooking={canAddSpecialAssistanceToBooking} />
  </Row>
);

Assistance.propTypes = {
  booking: bookingShape,
  canAddSpecialAssistanceToBooking: PropTypes.bool.isRequired
};

export default Assistance;
